<template>
  <div class="card width-340">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <h1 class="title is-size-3 mgt-20px">
        {{ $t('editLotPaiement.popUpEditionReferencePaiement.title') }}
      </h1>
    </div>
    <div class="card-content">
      <b-field :label="$t('editLotPaiement.popUpEditionReferencePaiement.referencePaiement')">
        <b-input v-model="referencePaiement" type="number"></b-input>
      </b-field>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit"
               @click="$emit('referencePaiement', referencePaiement)">
              {{ $t('general.button.valider') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popUpEditionReferencePaiement',
  data() {
    return {
      referencePaiement: null,
    };
  },
};
</script>

<style scoped>

</style>
